export default "__VITE_ASSET__c406111c__"